import React, { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import { apiPost, mediaUrl } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";

const BannerArrow = ({ className, onClick, dir }) => (
  <button
    type="button"
    aria-label={dir === "prev" ? "Previous banner" : "Next banner"}
    className={`main-banner-arrow main-banner-arrow--${dir} ${className || ""}`}
    onClick={onClick}
  />
);

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <BannerArrow dir="prev" />,
  nextArrow: <BannerArrow dir="next" />,
  customPaging: () => <span />,
  lazyLoad: "ondemand",
};

const MainBanner = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      const { status, data } = await apiPost(apiPath.getBanner, {
        type: "home_top",
      });
      if (active && status === 200 && data?.success) {
        setBanners(data?.results?.banners || []);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const slides = useMemo(() => banners, [banners]);

  if (!slides.length) {
    return null;
  }

  return (
    <div className="main-banner">
      <Slider {...sliderSettings}>
        {slides.map((item, index) => (
          <div className="slider-items-banner" key={item?._id || item?.banner_path}>
            <figure className="mb-0">
              <img
                src={mediaUrl(item?.banner_path)}
                alt=""
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={index === 0 ? "high" : "low"}
              />
            </figure>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MainBanner;
